export const RandomID = () => {
  return '_' + Math.random().toString(36).substring(2, 9);
};

export * from './urlRoutes';
